import React, { memo } from "react";
import { Breadcrumb } from "./BreadcrumbsProvider";
import { useCrumb } from "./useCrumb";

export const Crumb: React.FC<Breadcrumb> = memo(({ label, to, type }) => {
  useCrumb({ label, to, type });
  return null;
});
